import React, { useState } from "react";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import styled from "styled-components";
import {
  Form,
  Input,
  Select,
  Button,
  Typography,
  Tooltip,
  InputNumber,
  Row,
  Col,
  Upload,
  message,
} from "antd";
import {
  CloseCircleFilled,
  InboxOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { createProperty } from "../api/propertyApi";
import { EditorState, convertToRaw } from "draft-js";
import Dragger from "antd/es/upload/Dragger";
import { useMediaQuery } from "../utils/mediaQueries";

const { Option } = Select;

const Container = styled.div`
  margin: 0 auto;
  width: 80vw;
  padding: 20px;
  background-color: #fff;

  @media (max-width: 1100px) {
    width: 100vw;
  }
`;

const FormContainer = styled.div`
  margin: 0 auto;
  width: 100%;
  padding: 20px;
`;

const FormTitle = styled.h1`
  text-align: center;
  margin-bottom: 20px;
`;

const FormButtonWrapper = styled.div`
  margin-top: 50px;
  display: flex;
  justify-content: center;
`;

const TextContainer = styled.div`
  margin-bottom: 20px;
`;

const FormsCol = styled(Col)`
  width: 49%;
`;

const CreatePostPage = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [amenities, setAmenities] = useState([]);
  const [images, setImages] = useState([]);
  const [descriptionEditorState, setDescriptionEditorState] = useState(
    EditorState.createEmpty()
  );

  const isMobile = useMediaQuery("(max-width: 1100px)");

  const { Title, Paragraph } = Typography;

  const onFinish = async (values) => {
    setLoading(true);
    const formData = new FormData();
    console.log(images);

    // handle image upload
    images.forEach((file) => {
      formData.append("images", file.originFileObj);
    });

    const rawDescription = convertToRaw(
      descriptionEditorState.getCurrentContent()
    );
    formData.append(
      "amenities",
      JSON.stringify({
        others: amenities,
        bathroom: values.bathroom,
        bedroom: values.bedroom,
      })
    );
    formData.append("location", values.location);
    formData.append("description", JSON.stringify(rawDescription)); // Convert object to string
    formData.append("price", values.price.toString()); // Convert number to string
    formData.append("propertySize", values.propertySize.toString()); // Convert number to string
    formData.append("propertyType", values.propertyType);
    formData.append("sellingPoint", values.sellingPoint);
    formData.append("status", values.status);
    console.log(formData);
    await createProperty(formData);
    window.location.reload();
    setLoading(false);
  };

  const handleFormReset = () => {
    form.resetFields();
    setAmenities([]);
    setImages([]);
  };

  const handleAddAmenity = () => {
    setAmenities([...amenities, ""]);
  };

  const handleAmenityChange = (index, value) => {
    const updatedAmenities = [...amenities];
    updatedAmenities[index] = value;
    setAmenities(updatedAmenities);
  };

  const handleRemoveAmenity = (index) => {
    const updatedAmenities = [...amenities];
    updatedAmenities.splice(index, 1);
    setAmenities(updatedAmenities);
  };

  const handleImageUpload = (fileList) => {
    setImages(fileList);
  };

  const columnWidth = isMobile ? 12 : 0;

  const propertyTypes = [
    "Agriculture Land",
    "Apartment",
    "Bungalow",
    "Bungalow Lot Land",
    "Corner Lot",
    "Double Storey Bungalow",
    "Double Storey Semi D",
    "Double Storey Shoplot",
    "Double Storey Terrace",
    "Residential Land",
    "Semi D Cluster",
    "Semi Detached",
    "Single Storey 1½ Terrace",
    "Single Storey Bungalow",
    "Single Storey Semi D",
    "Single Storey Shoplot",
    "Single Storey Terrace",
    "Single Storey Terrace Endlot",
    "Three Storey Bungalow",
    "Three Storey Shoplot",
  ];

  return (
    <Container>
      <FormContainer>
        <FormTitle>Reka Posting</FormTitle>
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          initialValues={{
            isFeatured: false,
            status: "jual",
            propertyType: "Residential Land",
          }}
        >
          <TextContainer>
            <Title level={4}>Maklumat asas</Title>
            <Paragraph>Isikan maklumat asas di bawah</Paragraph>
          </TextContainer>
          <Row gutter={24}>
            <FormsCol span={12 + columnWidth}>
              <Form.Item
                label="Lokasi"
                name="location"
                rules={[{ required: true, message: "Sila masukkan lokasi" }]}
              >
                <Input placeholder="Address Line 1, Address Line 2, Postal Code City, State Country" />
              </Form.Item>
            </FormsCol>
            <FormsCol span={12 + columnWidth}>
              <Form.Item
                name="propertySize"
                label="Saiz Harta (m2)"
                rules={[
                  {
                    required: true,
                    message: "Sila masukkan keluasan tanah anda",
                  },
                ]}
              >
                <Input type="number" placeholder="E.g. 5000" />
              </Form.Item>
            </FormsCol>
            <FormsCol span={12 + columnWidth}>
              <Form.Item
                label="Price"
                name="price"
                rules={[{ required: true, message: "Sila masukkan harga" }]}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  min={0}
                  step={10000}
                  placeholder="E.g. 100000"
                />
              </Form.Item>
            </FormsCol>
            <FormsCol span={12 + columnWidth}>
              <Form.Item
                name="sellingPoint"
                label="Titik Jualan"
                rules={[
                  {
                    required: true,
                    message: "Sila masukkan keluasan tanah anda",
                  },
                ]}
              >
                <Input type="text" placeholder="E.g. Dekat dengan MRT" />
              </Form.Item>
            </FormsCol>
          </Row>
          <Row gutter={24}>
            <FormsCol span={12 + columnWidth}>
              <Form.Item
                name="amenities"
                label="Kemudahan"
                rules={[
                  {
                    // required: true,
                    message: "Sila masukkan kemudahan hartanah",
                  },
                ]}
              >
                {amenities.map((amenity, index) => (
                  <div key={index} style={{ display: "flex" }}>
                    <Input
                      value={amenity}
                      onChange={(e) =>
                        handleAmenityChange(index, e.target.value)
                      }
                      placeholder="Masukkan kemudahan hartanah"
                      suffix={
                        <Tooltip title="Diklik untuk memusnahkan kemudahan">
                          <CloseCircleFilled
                            onClick={() => handleRemoveAmenity(index)}
                          />
                        </Tooltip>
                      }
                    />
                  </div>
                ))}
                <Button type="dashed" onClick={handleAddAmenity} block>
                  Tambah Kemudahan
                </Button>
              </Form.Item>
            </FormsCol>
            <FormsCol span={12 + columnWidth}>
              <Form.Item name="isFeatured" label="Ditampilkan">
                <Select>
                  <Option value={true}>Betul</Option>
                  <Option value={false}>Salah</Option>
                </Select>
              </Form.Item>
            </FormsCol>
          </Row>
          <Row gutter={24}>
            <FormsCol span={12 + columnWidth}>
              <Form.Item
                label="Bilik Air"
                name="bathroom"
                rules={[
                  {
                    required: true,
                    message: "Sila masukkan bilangan bilik air",
                  },
                ]}
              >
                <InputNumber
                  min={0}
                  step={1}
                  style={{ width: "100%" }}
                  placeholder="E.g. 2"
                />
              </Form.Item>
            </FormsCol>
            <FormsCol span={12 + columnWidth}>
              <Form.Item
                label="Bilik Tidur"
                name="bedroom"
                rules={[
                  {
                    required: true,
                    message: "Sila masukkan bilangan bilik tidur",
                  },
                ]}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  placeholder="E.g. 2"
                  min={0}
                  step={1}
                />
              </Form.Item>
            </FormsCol>
            <FormsCol span={12 + columnWidth}>
              <Form.Item
                name="status"
                label="Status"
                rules={[
                  { required: true, message: "Sila pilih status urusan" },
                ]}
                style={{ width: "100%" }}
              >
                <Select defaultValue="jual">
                  <Option value="jual">Jual</Option>
                  <Option value="sewa">Sewa</Option>
                </Select>
              </Form.Item>
            </FormsCol>
            <FormsCol span={12 + columnWidth}>
              <Form.Item
                name="propertyType"
                label="Jenis Hartanah"
                rules={[
                  {
                    required: true,
                    message: "Sila pilih jenis hartanah",
                  },
                ]}
                style={{ width: "100%" }}
              >
                <Select>
                  {propertyTypes.map((type) => (
                    <Option key={type} value={type}>
                      {type}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </FormsCol>
          </Row>
          <Row gutter={24}>
            <FormsCol span={24}>
              <Form.Item
                label="Description"
                name="description"
                rules={[{ required: true, message: "Sila masukkan huraian" }]}
              >
                <Editor
                  toolbarClassName="toolbarClassName"
                  wrapperClassName="wrapperClassName"
                  editorClassName="editorClassName"
                  placeholder="Tulis penerangan anda di sini"
                  editorState={descriptionEditorState}
                  onEditorStateChange={setDescriptionEditorState}
                />
              </Form.Item>
            </FormsCol>
          </Row>
          <Row gutter={24}>
            <FormsCol span={24}>
              <Form.Item
                label="Images"
                name="images"
                rules={[
                  {
                    required: true,
                    message: "Sila letak sekurang-kurangnya 1 gambar",
                  },
                ]}
              >
                <Dragger
                  listType="picture"
                  beforeUpload={(file) => {
                    const allowedTypes = [
                      "image/png",
                      "image/jpeg",
                      "image/jpg",
                    ];
                    const isAllowed = allowedTypes.includes(file.type);

                    console.log(isAllowed);
                    if (!isAllowed) {
                      message.error(
                        "Only PNG, JPEG, and JPG files are allowed!"
                      );
                    }
                    return isAllowed ? false : Upload.LIST_IGNORE;
                  }}
                  onChange={({ fileList }) => handleImageUpload(fileList)}
                  multiple
                >
                  <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                  </p>
                  <p className="ant-upload-text">
                    Click or drag file to this area to upload
                  </p>
                  <p className="ant-upload-hint">
                    Support for a single or bulk upload.
                  </p>
                </Dragger>
              </Form.Item>
            </FormsCol>
          </Row>
          <FormButtonWrapper>
            <Button type="primary" htmlType="submit" loading={loading}>
              Submit
            </Button>
            <Button type="default" onClick={handleFormReset}>
              Reset
            </Button>
          </FormButtonWrapper>
        </Form>
      </FormContainer>
    </Container>
  );
};

export default CreatePostPage;
